export default __webpack_public_path__ + "a947bf020b26ea85daa17dfd2a1a17e902ab18ff/88bf19232e48cd6fe29f018005128e1e.png";